import {Pipe, PipeTransform} from '@angular/core';

/**
 * Умная расшифровка поля `data` из admin_log:
 *  - строка (legacy формат "Заблокирован. isLocked: ...") → возвращаем как есть
 *  - объект с полем reason ({reason: "..."}) → возвращаем содержимое reason
 *  - другой объект → JSON.stringify (чтобы не было [object Object])
 *  - null/undefined → '—'
 */
@Pipe({
  name: 'logDataReason'
})
export class LogDataReasonPipe implements PipeTransform {
  transform(value: unknown): string {
    if (value == null) return '—';
    if (typeof value === 'string') return value;
    if (typeof value === 'object') {
      const reason = (value as { reason?: unknown }).reason;
      if (reason != null) return String(reason);
      try {
        return JSON.stringify(value);
      } catch {
        return String(value);
      }
    }
    return String(value);
  }
}
